<div class="mat-mdc-dialog-surface">
  <div fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="center center" style="padding-bottom: 20px;">
      <div>
        <mat-progress-spinner mode="determinate" diameter="120" [color]="colorValue" [value]="counter"></mat-progress-spinner>
        <h1 style="padding-top: 15px; text-align: center;">{{showCounter}}</h1>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center">
      <h1 mat-dialog-title>{{data.alertTitle}}</h1>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" style="padding-bottom: 20px;">
      <label>{{data.alertMessage}}</label>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
      <button mat-stroked-button mat-dialog-close color="warn" (click)="onCancelClick()">Cancel</button>
      <button mat-flat-button color="warn" [mat-dialog-close]="true" (click)="logoutUser()" cdkFocusInitial>LogOut</button>
    </div>
  </div>
</div>
